import type React from 'react';

interface CopyIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const CopyIcon: React.FC<CopyIconProps> = ({ width = 16, height = 16, color = '#656565' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <rect x="9" y="9" width="12" height="12" rx="2" />
        <path d="M5 15V5a2 2 0 0 1 2-2h8" />
    </svg>
);

export default CopyIcon;
